function loadView (view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

export default [
  {
    path: '',
    name: 'TeamHome',
    component: loadView('Front/Team/Players')
  },
  {
    path: 'tournaments-where-we-play',
    name: 'TeamTournaments',
    component: loadView('Front/Team/Tournaments')
  },
  {
    path: 'training',
    name: 'TeamTraining',
    component: loadView('Front/Team/Training')
  },
  {
    path: 'notices',
    name: 'TeamNotices',
    component: loadView('Front/Team/Notices')
  },
  {
    path: 'notices/:noticeSlug',
    name: 'TeamNotice',
    component: loadView('Front/Team/Notice'),
  },
  {
    path: 'the-bests',
    name: 'TeamBests',
    component: loadView('Front/Team/TheBests'),
  },
  {
    path: 'the-bests-scorers',
    name: 'TeamScorers',
    component: loadView('Front/Team/Scorers'),
  },
  {
    path: 'last-matches',
    name: 'TeamLastMatches',
    component: loadView('Front/Team/LastMatches'),
  },
  {
    path: 'fixture',
    name: 'TeamFixture',
    component: loadView('Front/Team/Fixture'),
  },
  {
    path: 'awards',
    name: 'TeamAwards',
    component: loadView('Front/Team/Awards'),
  }
]
